import { IApiEpBillingBill, IApiEpBillingRecurringPayment } from "@smp/api";

import { yaReachGoal } from "@/utils/ya_reach_goal";

import { dataLayerPush } from "./data_layer_push";

type Bill = Pick<
  IApiEpBillingBill,
  "currency" | "id" | "product_id" | "description" | "amount"
>;

type RecurringPayment = Pick<
  IApiEpBillingRecurringPayment,
  "confirm_widget_args" | "product_regular"
>;

type Params = Bill | RecurringPayment;

const STORAGE_KEY = "ep.metric.accounted_invoice_set";

const isRecurringPayment = (data: Params): data is RecurringPayment =>
  "confirm_widget_args" in data;

export const dataLayerPushEcommerce = (data: Params) => {
  const invoiceId = isRecurringPayment(data)
    ? data.confirm_widget_args.invoiceId
    : data.id;
  const invoiceIds: number[] =
    typeof window !== "undefined"
      ? JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]")
      : [];

  if (invoiceIds.includes(invoiceId)) {
    return;
  }

  if (typeof window !== "undefined") {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify([...invoiceIds, invoiceId]),
    );
  }

  yaReachGoal("payment");

  if (data) {
    if (isRecurringPayment(data)) {
      dataLayerPush({
        ecommerce: {
          currencyCode: data.confirm_widget_args.currency,
          purchase: {
            actionField: {
              id: `recurring-${data.confirm_widget_args.invoiceId}`,
            },
            products: [
              {
                id: data.product_regular.toString(),
                name: data.confirm_widget_args.description,
                price: data.confirm_widget_args.amount,
                quantity: 1,
              },
            ],
          },
        },
      });
    } else {
      dataLayerPush({
        ecommerce: {
          currencyCode: data.currency,
          purchase: {
            actionField: {
              id: `bill-${data.id}`,
            },
            products: [
              {
                id: data.product_id?.toString() || "refill",
                name: data.description,
                price: parseFloat(data.amount),
                quantity: 1,
              },
            ],
          },
        },
      });
    }
  }
};
